import { render, staticRenderFns } from "./LostIdTag.vue?vue&type=template&id=7b7777d4&"
import script from "./LostIdTag.vue?vue&type=script&lang=ts&"
export * from "./LostIdTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports